module.exports = __webpack_public_path__ + "static/solutions_salesforce-58a11f2251c6b2ba97248a0a040ab783.svg";